import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X, MapPin } from 'lucide-react';
const NAMES = ['Romina', 'Marcela', 'Luciana', 'Sofía', 'Carla', 'Valeria', 'Daniela', 'Gabriela', 'Florencia', 'Lorena', 'Natalia', 'Cecilia', 'Verónica', 'Andrea', 'Mariana', 'Paula', 'Silvina', 'Belén', 'Agustina', 'Patricia', 'Mónica', 'Estefanía', 'Javier', 'Martín', 'Sebastián', 'Diego', 'Federico', 'Gonzalo'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Resistencia', 'Posadas', 'Bahía Blanca', 'Paraná', 'San Juan', 'Quilmes', 'Lanús', 'Río Cuarto', 'Comodoro Rivadavia', 'San Luis'];
const OFFERS = [{
  label: 'el MEGAPACK PRO',
  price: '$29.990'
}, {
  label: 'el pack TDAH EN CALMA',
  price: '$19.990'
}];
type Notification = {
  name: string;
  city: string;
  offer: string;
  price: string;
  minutes: number;
};
const rand = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
const pick = <T,>(arr: T[]): T => arr[rand(0, arr.length - 1)];
function buildNotification(): Notification {
  const offer = pick(OFFERS);
  return {
    name: pick(NAMES),
    city: pick(CITIES),
    offer: offer.label,
    price: offer.price,
    minutes: rand(1, 18)
  };
}
export function PurchasePopup() {
  const [notification, setNotification] = useState<Notification | null>(null);
  const [visible, setVisible] = useState(false);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    const clearTimers = () => {
      timers.current.forEach(t => window.clearTimeout(t));
      timers.current = [];
    };
    const showOnce = () => {
      setNotification(buildNotification());
      setVisible(true);
      // Keep it on screen for ~6 seconds
      const hideTimer = window.setTimeout(() => {
        setVisible(false);
        // Schedule the next popup 40–60s after this one hides
        const nextTimer = window.setTimeout(showOnce, rand(40000, 60000));
        timers.current.push(nextTimer);
      }, 6000);
      timers.current.push(hideTimer);
    };
    // First popup shortly after load
    const firstTimer = window.setTimeout(showOnce, 6000);
    timers.current.push(firstTimer);
    return clearTimers;
  }, []);
  const handleClose = () => setVisible(false);
  return <div aria-live="polite" className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] sm:max-w-sm pointer-events-none" data-id="element-293">
      <AnimatePresence data-id="element-294">
        {visible && notification && <motion.div role="status" initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto flex items-start gap-3 bg-white rounded-2xl shadow-2xl border border-[#1E2A4A]/10 p-3 pr-9 relative" data-id="element-295">
            <button type="button" onClick={handleClose} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-[#1E2A4A]/30 hover:text-[#1E2A4A]/70 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E76F51] rounded" data-id="element-296">
              <X size={16} data-id="element-297" />
            </button>

            <div className="shrink-0 w-10 h-10 rounded-full bg-[#8A9A86]/15 flex items-center justify-center" data-id="element-298">
              <BadgeCheck size={22} className="text-[#8A9A86]" data-id="element-299" />
            </div>

            <div className="min-w-0" data-id="element-300">
              <p className="text-sm text-[#1E2A4A] leading-snug" data-id="element-301">
                <span className="font-bold" data-id="element-302">{notification.name}</span> compró{' '}
                <span className="font-bold" data-id="element-303">{notification.offer}</span>
              </p>
              <p className="flex items-center gap-1 text-xs text-[#1E2A4A]/60 mt-0.5" data-id="element-304">
                <MapPin size={12} className="text-[#E76F51]" data-id="element-305" />
                {notification.city}, Argentina
              </p>
              <p className="text-[11px] font-semibold text-[#8A9A86] mt-1" data-id="element-306">
                Hace {notification.minutes} min · Compra verificada ✓
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}